import { useCallback } from 'react';

import { useTimeZone } from '@/auth/useTimeZone.js';
import { getNowPlainDateISO } from '@/lib/time-zones.js';

/** Read today's date when invoked, using the acting user's preferred time zone. */
export function useNowPlainDateISO() {
  const { timeZone } = useTimeZone();
  return useCallback(() => getNowPlainDateISO(timeZone), [timeZone]);
}
